import { Check, Error, MoreHoriz, RocketLaunch } from "@mui/icons-material";
import { Avatar, Badge, Chip } from "@mui/material";
import React from "react";

export default function AudioFileStatusIndicator({
  status = "",
  showBadge = false,
  avatarBgColor = "rgba(0, 0, 0, 0.2)",
  iconColor = "white",
}) {
  const { icon, color, label } = getStatusLabelIconColor(status);

  const ChipContent = (
    <Chip
      avatar={
        <Avatar sx={{ bgcolor: avatarBgColor }}>
          {React.cloneElement(icon, { sx: { color: iconColor, width: "16px" } })}
        </Avatar>
      }
      label={label}
      size="medium"
      sx={{
        bgcolor: color,
        color: "white",
        borderRadius: "20px",
        width: "120px",
        height: "30px",
        justifyContent: "start",
        "& .MuiChip-avatar": { marginRight: "2px" },
      }}
    />
  );

  return showBadge ? (
    <Badge
      overlap="circular"
      badgeContent=""
      variant="dot"
      color={"error"}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ "& .MuiBadge-dot": { minWidth: "8px", height: "8px", right: "10px", top: "4px" } }}
    >
      {ChipContent}
    </Badge>
  ) : (
    ChipContent
  );
}

const getStatusLabelIconColor = (status: string) => {
  // Options from ProcessStatus API interface:
  // STARTED
  // COMPLETED
  // FAILED

  switch (status.toLowerCase()) {
    case "started":
      return {
        icon: <RocketLaunch />,
        color: "#00A3E0",
        label: "Transcribing",
      };

    case "completed":
      return {
        icon: <Check />,
        color: "#2E7D32",
        label: "Complete",
      };

    case "failed":
      return { icon: <Error />, color: "#D32F2F", label: "File Error" };

    default:
      return {
        icon: <MoreHoriz />,
        color: "#BBBBBB", //"#EF6C00",
        label: "Pending",
      };
  }
};
